import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-paper-icon',
  templateUrl: './general-paper.component.html'
})
export class GeneralPaperComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
